import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ValidationErrors } from '@angular/forms';

@Component({
  selector: 'app-validation-errors',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './validation-errors.component.html',
  styleUrls: ['./validation-errors.component.scss']
})
export class ValidationErrorsComponent implements OnChanges {
  @Input() errors: Record<string, ValidationErrors> | null = {};
  @Input() customErrorMessages: Record<string, string> = {};
  @Input() customSingleErrorMessage: string = '';
  errorMessages: Record<string, string> = {
    required: 'Campo obrigatório',
    invalidMonth: 'O mês está inválido',
    invalidDay: 'O dia está inválido',
    futureDate: 'Não pode ser inserida uma data futura',
    invalidDate: 'Formato inválido',
    invalidCpf: 'CPF inválido',
    invalidLogin: 'Login inválido',
    expiredDate: 'Data expirada',
    minlength: 'Valor mínimo não atingido'
  };

  ngOnChanges(changes: SimpleChanges): void {
    const { customErrorMessages } = changes;
    if (customErrorMessages) {
      this.errorMessages = {
        ...this.errorMessages,
        ...customErrorMessages.currentValue,
      };
    }
  }
}
